import classnames from 'classnames';
import React, { useRef, useState, useEffect, cloneElement } from 'react';
import { useHover, useLayer, Arrow } from 'react-laag';
import { Transition } from 'react-transition-group';
import { Placements } from '../../../../enums/placements.js';
import { TooltipTypes } from '../../../../enums/tooltip.js';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import 'styled-components';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import '../../../../styles/styled-components/tooltip.js';
import { transitionFadeIn } from '../../../../styles/transitions/fade-in.js';
import '../../../../utilities/color.js';
import 'date-fns';
import '../../../../utilities/locale.js';
import { mergeRefs } from '../../../../utilities/refs.js';
import classes from './styles/base-tooltip.module.scss.js';

const baseName = 'tooltip';
const BaseTooltip = (props)=>{
    const { children, defaultOpen, id, onClose, onOpen, openOnFocus = true, openOnHover = true, placement = Placements.TopCenter, tooltip, transitionDelay = 0, transitionDuration = 200, triggerOffset = 5, type = TooltipTypes.Description, variantName, wrapperProps, ...otherProps } = props;
    const nodeRef = useRef(null);
    const [isOver, hoverProps] = useHover();
    const [open, setOpen] = useState(defaultOpen || false);
    const isOpen = openOnHover && isOver || open;
    const handleKeyUp = (e)=>{
        const { key } = e;
        if (key === 'Escape') {
            setOpen(false);
        }
    };
    const handleOnClose = ()=>{
        if (onClose) {
            onClose();
        }
    };
    const handleOnOpen = ()=>{
        if (onOpen) {
            onOpen();
        }
    };
    const { arrowProps, layerProps, renderLayer, triggerProps } = useLayer({
        arrowOffset: 0,
        auto: true,
        containerOffset: 0,
        isOpen,
        overflowContainer: true,
        placement,
        triggerOffset
    });
    const { ref, style: layerPropsStyle, ...otherLayerProps } = layerProps;
    useEffect(()=>{
        setOpen(defaultOpen || false);
    }, [
        defaultOpen
    ]);
    const timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
    return /*#__PURE__*/ React.createElement("span", {
        ...triggerProps,
        ...hoverProps,
        ...wrapperProps,
        className: classnames(`bf-${baseName}__${variantName}--wrapper`, wrapperProps && wrapperProps.className)
    }, /*#__PURE__*/ cloneElement(children, {
        'aria-describedby': type === TooltipTypes.Description ? id : undefined,
        'aria-labelledby': type === TooltipTypes.Label ? id : undefined,
        onBlur: ()=>{
            if (openOnFocus) {
                setOpen(false);
                handleOnClose();
            }
        },
        onFocus: ()=>{
            if (openOnFocus) {
                setOpen(true);
                handleOnOpen();
            }
        },
        onKeyUp: (e)=>handleKeyUp(e)
    }), renderLayer(/*#__PURE__*/ React.createElement(Transition, {
        appear: isOpen,
        in: isOpen,
        mountOnEnter: true,
        nodeRef: nodeRef,
        timeout: timeout,
        unmountOnExit: true
    }, (transitionStatus)=>/*#__PURE__*/ React.createElement("p", {
            ...otherLayerProps,
            ...otherProps,
            className: classnames(`bf-${baseName}__${variantName}`, otherProps && otherProps.className, classes['prefers-reduce-motion']),
            id: id,
            ref: mergeRefs([
                nodeRef,
                ref
            ]),
            role: "tooltip",
            style: {
                ...layerPropsStyle,
                ...transitionFadeIn({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                })
            }
        }, tooltip, /*#__PURE__*/ React.createElement(Arrow, {
            onPointerEnterCapture: undefined,
            onPointerLeaveCapture: undefined,
            ...arrowProps,
            className: classnames(`bf-${baseName}__${variantName}__arrow`, `bf-${baseName}__${variantName}__arrow--${placement}`, classes.arrow)
        })))));
};

export { BaseTooltip };
//# sourceMappingURL=base-tooltip.js.map
